/*
    This is the form controller. It handles the data manipulation

    Fetching when displayed and then submitting the data

*/
import React, { useState } from 'react'
import moment from 'moment'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import EditJob from '../../EditJob.form'

// queries
import { useMutation } from '@apollo/client'
import { apolloClient } from '../../../../../index'
import { EDIT_JOB } from '../../../../../graphql/job/job.mutations'
import { GET_JOB_BY_ID_FOR_EDIT_FORM, GET_ALL_JOB_DAYS_FOR_JOB, GET_ALL_EQUIPMENT_REQUESTS_FOR_JOB, GET_JOB_BY_ID_WITH_CUSTOMER, GET_JOB_BY_ID_WITH_INFO, GET_JOB_BY_ID_NAME } from '../../../../../graphql/job/job.queries'

// utils
import { validate } from '../../../../../shared/utility'

const validationSchema = {
    name: {
        type: 'input',
        validation: {
            required: true
        }
    },
    estimatedStartDate: {
        type: 'date',
        validation: {
            isDate: true
        }
    }
}

export default function EditJobFormController({ id, visible, closeForm }) {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [job, setJob] = useState(null)
    const [editJob, { data, loading, error }] = useMutation(EDIT_JOB)
    const [errors, setErrors] = useState({})

    // handle the form submission
    const handleSubmit = (formData) => {

        const { isValid, errors } = validate(formData, validationSchema)

        let submitData = {...formData}
        if(formData.estimatedStartDate !== null && formData.estimatedStartDate.isValid()) {
            submitData['estimatedStartDate'] = formData.estimatedStartDate.format("YYYY-MM-DD")
        } else if(formData.estimatedStartDate == null) {
            submitData['estimatedStartDate'] = null
        }
        submitData.id = Number(submitData.id)
        if(isValid) {
            editJob({ variables: {...submitData}, refetchQueries:[GET_ALL_JOB_DAYS_FOR_JOB, GET_ALL_EQUIPMENT_REQUESTS_FOR_JOB, GET_JOB_BY_ID_WITH_CUSTOMER, GET_JOB_BY_ID_WITH_INFO, GET_JOB_BY_ID_NAME]}).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({})
                    closeForm()
                    setIsFetchingObject(true)
                }
            })
        } else {
            setErrors(errors)
        }
    }
    // what to do when first loading
    if(visible && isFetchingObject) {

        // fetch the data
        apolloClient.query({ query: GET_JOB_BY_ID_FOR_EDIT_FORM, variables: { id }}).catch(e => {
            console.error(e)
        }).then(result => {
            if(result) {
                setJob({...result.data.job, estimatedStartDate: result.data.job.estimatedStartDate ? moment(result.data.job.estimatedStartDate) : null})
                setIsFetchingObject(false)
            }
        })

        return (null)

    }

    else if(visible && !isFetchingObject && job) {
        const editVariants = [{
            name: '',
            component: <EditJob />,
            stages: 1
        }]
        return (<SideViewModal 
            show={visible} 
            submitText='Save Changes'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({})
                closeForm()
            }}  
            title='Edit Job' 
            variants={editVariants}    
            prefillData={job}
            errors={errors}
        />)
    }

    return null
}
